import { ReactComponent as Dashboard } from '../assets/icons/main/dashboard-icon.svg';
import { ReactComponent as Ontology } from '../assets/icons/main/ontology-icon.svg';
import { ReactComponent as Platform } from '../assets/icons/main/service-icon.svg';
import { ReactComponent as Component } from '../assets/icons/main/component-icon.svg';
import { ReactComponent as ontologyManagement } from '../assets/icons/main/ontology-management-icon.svg';
import { ReactComponent as Machine } from '../assets/icons/main/machine-icon.svg';
import { ReactComponent as Gateway } from '../assets/icons/main/gateway-icon.svg';
import { ReactComponent as Build } from '../assets/icons/main/deploy-icon.svg';
import { ReactComponent as Live } from '../assets/icons/main/live-icon.svg';
import { ReactComponent as Account } from '../assets/icons/main/account-icon.svg';
import { ReactComponent as FactoryIcon } from '../assets/icons/main/factory-icon.svg';
import { ReactComponent as ConDashboard } from '../assets/icons/main/live-icon.svg';
import { ReactComponent as DigitalTwin } from '../assets/icons/main/digital-twin-icon.svg';
import { ReactComponent as SecretManger } from '../assets/icons/main/shield-lock-icon.svg';
import { ReactComponent as MaintIcon } from '../assets/icons/main/machine-maint-icon.svg';
import { ReactComponent as NewUseCase } from '../assets/icons/main/flow-icon.svg';

import { ReactComponent as CatDashboard } from '../assets/icons/main/menu/dashboard-icon.svg';
import { ReactComponent as PlatfromConfig } from '../assets/icons/main/menu/platform-icon.svg';
import { ReactComponent as SmartFactory } from '../assets/icons/main/menu/smart-factory-icon.svg';
import { ReactComponent as OperationalIntelligence } from '../assets/icons/main/menu/oper-intelligence-icon.svg';
import { ReactComponent as Applciations } from '../assets/icons/main/menu/custom-app-icon.svg';
import { ReactComponent as AccessControl } from '../assets/icons/main/menu/access-control-icon.svg';

import { ReactComponent as GPTIcon } from '../assets/icons/main/gpt-icon.svg';
import { ReactComponent as EmSaverIcon } from '../assets/icons/main/emsaver-icon.svg';

export const groupSequence: any = ["dashboard", "platform_config", "smart_factory", "operational_intelligence", "application", "access_control"];

export const iconList: any = {
  CatDashboard,
  Dashboard,
  Ontology,
  Platform,
  Component,
  ontologyManagement,
  Machine,
  MaintIcon,
  Gateway,
  FactoryIcon,
  Build,
  ConDashboard,
  DigitalTwin,
  Account,
  SecretManger,
  PlatfromConfig,
  SmartFactory,
  OperationalIntelligence,
  Applciations,
  AccessControl,
  NewUseCase,
  GPTIcon,
  EmSaverIcon
};

export const menuList: any = [
  {
    id: 1,
    title: 'Dashboards',
    Icon: 'CatDashboard',
    type: 'dashboard',
    hidden: false,
    haveSubMenu: true,
    children: [],
    //  { id: 1, title: 'Dashboard', type: 'dashboard', Icon: 'Dashboard', path: '/dashboard', route_id: 'dashboard', isSubMenu: true, isDefault: false }
  },
  {
    id: 2,
    title: 'Platform Configuration',
    Icon: 'PlatfromConfig',
    type: 'platform_config',
    hidden: false,
    haveSubMenu: true,
    children: [
      {
        id: 1,
        title: 'Ontology Master',
        path: '/ontology',
        info: 'Organizations can create their own Ontology levels as per the requirements.For Example: Country, State, City and Site.',
        Icon: 'Ontology',
        endPointPath: 'site/levels',
        route_id: 'site_levels',
        type: 'ontology_master',
        hidden: false,
        isSubMenu: true
      },
      {
        id: 2,
        title: 'Integration Services',
        path: '/integration',
        info: 'Any Service which works on TCP or UDP protocols can be configured as a part of Services Master.',
        Icon: 'Platform',
        endPointPath: 'things/services',
        route_id: 'things_services',
        type: 'integration_services',
        hidden: false,
        isSubMenu: true
      },
      {
        id: 3,
        title: 'Component Master',
        path: '/component',
        info: 'The component is any software which is required at the edge to interact with surrounding software or hardware components. ( Example: OPC Server, Modbus Server, SQL Database)',
        Icon: 'Component',
        endPointPath: 'things/components',
        route_id: 'things_components',
        type: 'component_master',
        hidden: false,
        isSubMenu: true
      }]
  },
  {
    id: 3,
    title: 'Smart Factory',
    Icon: 'SmartFactory',
    type: 'smart_factory',
    hidden: false,
    haveSubMenu: true,
    children: [
      {
        id: 1,
        title: 'Ontology Management',
        path: '/assets/ontology',
        info: "Based on Ontology levels guidance created under Platform Configuration Master. Accordingly, you can define your organization's Ontology in this module.",
        Icon: 'ontologyManagement',
        endPointPath: 'site/master',
        route_id: 'site_master',
        type: 'ontology_management',
        hidden: false,
        isSubMenu: true
      },
      {
        id: 2,
        title: 'Machinery Management',
        path: '/assets/machinery',
        info: 'This feature lets you specify the types of devices used in your organization and link spare parts to each device.',
        Icon: 'Machine',
        endPointPath: 'things/machines',
        route_id: 'things_machines',
        type: 'machinery_management',
        hidden: false,
        isSubMenu: true,
        children: [
          {
            id: 1,
            title: 'Part Management',
            path: '/assets/machinery/:machine_id/parts',
            endPointPath: 'things/parts',
            route_id: 'things_parts',
          },
        ],
      },
      {
        id: 3,
        title: 'Gateways Management',
        path: '/assets/gateways',
        Icon: 'Gateway',
        endPointPath: 'things/gateways',
        route_id: 'things_gateways',
        type: 'gateways_management',
        hidden: false,
        isSubMenu: true,
        children: [
          { id: 1, title: 'OT Assets', path: '/assets/gateways/OTAsset' },
          { id: 2, title: 'Services', path: '/assets/gateways/OTAsset/services' },
          { id: 3, title: 'Parameters', path: '/assets/gateways/OTAsset/services/parameters' },
        ],
      },
      {
        id: 4,
        title: 'Factory Management',
        path: '/assets/factory-management',
        Icon: 'FactoryIcon',
        endPointPath: 'site/factory',
        route_id: 'site_factory',
        type: 'factory_management',
        hidden: false,
        isSubMenu: true,
        children: [
          {
            id: 1,
            title: 'Factory Management',
            path: '/assets/factory-management/:factoryId',
            endPointPath: 'site/factory',
            route_id: 'site_factory_edit',
          },
          {
            id: 2,
            title: 'Factory Management',
            path: '/assets/factory-management/pending-approval/all',
            endPointPath: 'site/factory',
            route_id: 'site_factory',
          },
          {
            id: 3,
            title: 'Factory Live View',
            path: '/assets/factory-management/:factoryId/live',
            endPointPath: 'site/factory',
            route_id: 'site_factory_live',
          },
        ],
      },
    ]
  },
  {
    id: 4,
    title: 'Operational Intelligence',
    Icon: 'OperationalIntelligence',
    type: 'operational_intelligence',
    hidden: false,
    haveSubMenu: true,
    children: [
      {
        id: 1,
        title: 'Connectivity Dashboard',
        path: '/connectivity-dashboard',
        Icon: 'ConDashboard',
        endPointPath: 'things/connectivity_dashboard',
        type: 'connectivity_dashboard',
        hidden: false,
        isSubMenu: true,
        children: [
          { id: 1, title: 'Connectivity Dashboard', path: '/connectivity-dashboard/:level_number/:onto_id' },
          { id: 2, path: '/connectivity-dashboard/assethistory/:asset_id', title: 'Connectivity Dashboard' },
          { id: 3, path: '/connectivity-dashboard/assets/:onto_manage_id/:type', title: 'Connectivity Dashboard' },
          { id: 4, path: '/connectivity-dashboard/assets/:onto_manage_id/:type/history/:asset_id', title: 'Connectivity Dashboard' },
          { id: 5, path: '/connectivity-dashboard/gateways/:onto_manage_id/:type', title: 'Connectivity Dashboard' },
          { id: 6, path: '/connectivity-dashboard/mqbroker/:onto_manage_id/:type', title: 'Connectivity Dashboard' },
          { id: 7, path: '/connectivity-dashboard/influx/:onto_manage_id/:type', title: 'Connectivity Dashboard' },
          { id: 8, path: '/connectivity-dashboard/:level_number/:onto_id', title: 'Connectivity Dashboard' },
        ],
      },
      {
        title: 'Use Case Management',
        Icon: 'Build',
        path: '/usecase-management',
        id: 2,
        endPointPath: 'use_case',
        route_id: 'usecase_management',
        type: 'usecase_management',
        hidden: false,
        isSubMenu: true,
        children: [
          { id: 1, path: '/usecase-management', title: 'Use Case Management', endPointPath: 'use_case' },
          { id: 2, path: 'usecase-management/grafana-templates', title: 'Use Case Management', endPointPath: 'use_case', },
          { id: 3, path: 'usecase-management/pending-approval', title: 'Use Case Management', endPointPath: 'use_case', }
        ]
      },
      {
        id: 3,
        title: 'Business Rule Engine',
        path: '/use-cases',
        Icon: 'NewUseCase',
        endPointPath: 'build_deploy/use_cases',
        route_id: 'build_deploy_use_cases',
        type: 'build_deploy_use_case',
        hidden: false,
        isSubMenu: true,
        children: [
          { id: 1, title: 'Use Case', path: '/use-cases/:useCaseId', endPointPath: 'build_deploy/use_cases' },
          {
            id: 2,
            title: 'Live Landscapes',
            path: '/use-cases/:useCaseId/live',
            endPointPath: 'build_deploy/use_cases',
          },
          {
            id: 3,
            title: 'Use Case',
            path: '/use-cases/pending-approval/all',
            endPointPath: 'build_deploy/use_cases',
            route_id: 'build_deploy_use_cases',
          },
        ],
      },
    ]
  },
  {
    id: 5,
    title: 'Applications',
    Icon: 'Applciations',
    type: 'application',
    hidden: false,
    haveSubMenu: true,
    children: [
      {
        id: 1, title: 'Maintenance Mgmt', path: '/maintenance-management', Icon: 'MaintIcon', endPointPath: 'maintenance', haveSubMenu: true,
        type: 'application_1',
        hidden: false,
        isSubMenu: true,
        children: [
          { id: 1, type: 'maintenance_overview', title: 'Maintenance Overview', path: '/maintenance-management', route_id: 'maintenance-management-home', isSubMenu: true },
          { id: 2, type: 'maintenance_plans', title: 'Maintenance Plans', path: '/maintenance-management/plan-list', route_id: 'plan-list', isSubMenu: true },
          { id: 3, type: 'maintenance_plans', title: 'Maintenance History', path: '/maintenance-management/history/:maintId', route_id: 'plan_history', },
          { id: 4, type: 'maintenance_activity', title: 'Activity History', path: '/maintenance-management/history/:maintId/activity/:actiId', route_id: 'activity_history', },
          { id: 5, type: 'maintenance_activity', title: 'Maintenance Activity', isSubMenu: true, path: '/maintenance-management/activity-list', route_id: 'activity-list', endPointPath: 'maintenance' },
          { id: 6, type: 'maintenance_activity', title: 'Maintenance Activity', path: '/maintenance-management/activity-list/add', route_id: 'activity_list', endPointPath: 'maintenance' },
          { id: 7, type: 'maintenance_activity', title: 'Maintenance Activity', path: '/maintenance-management/activity-list/edit/:activityId', route_id: 'activity-list', endPointPath: 'maintenance' },
          { id: 8, type: 'maintenance_activity', title: 'Maintenance Activity', path: '/maintenance-management/activity-list/view/:activityId', route_id: 'activity-list', endPointPath: 'maintenance' },
          { id: 9, type: 'maintenance_plans', title: 'Add New Maintenance Plan', path: '/maintenance-management/plan-list/add', route_id: 'plan-list', },
          { id: 1, type: 'maintenance_plans', title: 'View Maintenance Plan', path: '/maintenance-management/plan-list/view/:planId', route_id: 'plan-list', },
          { id: 2, type: 'maintenance_plans', title: 'Edit Maintenance Plan', path: '/maintenance-management/plan-list/edit/:planId', route_id: 'plan-list', },
          { id: 3, type: 'maintenance_machine', title: 'Machine Maintenance Status', isSubMenu: true, path: '/maintenance-management/machine-list', route_id: 'machine-list', endPointPath: 'maintenance' },
          { id: 4, type: 'maintenance_plans', title: 'Maintenance Plans', path: '/maintenance-management/plan-list/corrective', route_id: 'plan-list' },
        ],
      },
      {
        id: 2,
        title: 'Digital Twin',
        path: '/digital-twin',
        Icon: 'DigitalTwin',
        endPointPath: 'digital_twin/twin',
        type: 'application_2',
        hidden: false,
        isSubMenu: true,
        children: [
          { id: 1, path: '/digital-twin/:dt_id/:application_mode', title: 'Digital Twin' },
        ]
      },
      {
        id: 3,
        title: 'HARMAN Navigator GPT',
        path: '/gpt',
        Icon: 'GPTIcon',
        endPointPath: 'gpt',
        type: 'application_3',
        hidden: false,
        isSubMenu: true,
        children: [],
      },
      {
        id: 4,
        title: 'Vibration Monitoring',
        path: '/emsaver',
        Icon: 'EmSaverIcon',
        endPointPath: 'emsaver',
        type: 'application_4',
        hidden: false,
        isSubMenu: true,
        children: [],
      },
    ]
  },
  {
    id: 6,
    title: 'Access Control',
    Icon: 'AccessControl',
    type: 'access_control',
    hidden: false,
    haveSubMenu: true,
    children: [
      {
        id: 1,
        title: 'Secrets Manager',
        path: '/secrets-manager/secrets',
        Icon: 'SecretManger',
        endPointPath: 'secrets',
        route_id: 'secrets_manager',
        type: 'secrets_manager',
        isSubMenu: true,
        children: [
          {
            id: 1,
            title: 'Secrets Manager',
            path: '/secrets-manager/secrets',
            endPointPath: 'secrets',
            route_id: 'secrets_manager',
          },
          {
            id: 2,
            title: 'Secrets Manager',
            path: '/secrets-manager/templates',
            endPointPath: 'secrets',
            route_id: 'secrets_manager',
          },
        ],
      },
      {

        id: 2,
        title: 'User Management',
        path: '/user-management',
        Icon: 'Account',
        endPointPath: 'auth/users',
        route_id: 'auth_users',
        type: 'user_management',
        hidden: false,
        isSubMenu: true,
        children: [
          {
            id: 1,
            title: 'User Access Control',
            path: '/user-management/:user_id/user-access-control',
            endPointPath: 'auth/users',
            route_id: 'auth_users',
          },
          {
            id: 2,
            title: 'User Role Access Control',
            path: '/user-management/:row_id/user-role-access-control',
            endPointPath: 'auth/roles',
            route_id: 'auth_users',
          },
          {
            id: 3,
            title: 'Profile',
            path: '/profile',
            route_id: 'auth_users',
          },
          {
            id: 4,
            title: 'Settings',
            path: '/setting',
            route_id: 'auth_users',
            endPointPath: 'tenant/settings',
          },
        ],
      },
    ]
  },
];

const getRoutePaths = () => {
  const result: any = [];

  const routesList = (routes: any) => {
    routes.forEach((item: any) => {
      if (item.hasOwnProperty('id')) {
        if (item.children) {
          const { children, ...ele } = item;
          result.push(ele);
          routesList(item.children);
        } else {
          result.push(item);
        }
      }
    });
    return result;
  };

  return routesList(menuList);
};

export const routePaths = getRoutePaths();

export const combineAllMenuItems = (menuData: any[]) => {
  const result: any[] = [];
  const flattenRoutes = (routes: any[]) => {
    routes.forEach((item: any) => {
      if (item && item.hasOwnProperty('id')) {
        if (item.children) {
          const { children, ...parent } = item;
          result.push(parent);
          flattenRoutes(children);
        } else {
          result.push(item);
        }
      }
    });
  };

  flattenRoutes(menuData);
  return result;
};